import React from 'react';
import Banner from '../CommonComponents/Banner';
import Header from '../LayoutComponents/Header';
import Footer from '../LayoutComponents/Footer';
const AboutUs = () => {
  return (
    <>
    <Header />
      <Banner 
        title="About Us"
        customHeight={true}
        textBlack={true}
      />

<section className="section zigzag-section text-center">
        <div className="container">
          <div className="row">
            <div className="col-md-10 mx-auto">
              <div className="fill-text1">
                <p>
                  Welcome to bluetidesolutions, your trusted companion in discovering the best hotels across
                  Australia. Our mission is to provide travelers with reliable, comprehensive, and
                  insightful reviews to help them find the perfect accommodations for their journeys.
                </p>

                <p>
                  At bluetidesolutions, we believe that every stay should be an exceptional experience, whether
                  you're traveling for business, leisure, or adventure. Our team of experienced travelers
                  and industry experts meticulously curates and evaluates hotels, ensuring that our
                  recommendations are based on firsthand experiences and professional insights. We cover a
                  wide range of hotel categories, from luxury and boutique hotels to eco-friendly,
                  budget-friendly, and casino hotels, catering to diverse preferences and needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
            <Footer />
      
    </>
  );
};

export default AboutUs;